import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getAllShops } from "store/Admin/shops/actions"
import {sitename} from "../../../constants/constants";

const Shops = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllShops())
  }, [dispatch])
  const Shops = useSelector(state => state?.shops?.Index ?? [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Shops" />
        </Container>
        <Table data={Shops} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Shops)
